<div class="page-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-left">
      <h1 class="page-title">Users Management</h1>
      <p class="page-subtitle">
        Manage registered athletes, inspect workout recordings, and configure
        permissions
      </p>
    </div>
    <div class="header-stats" *ngIf="totalRecords">
      <span class="stat-pill">
        <mat-icon>people</mat-icon>
        <strong>{{ totalRecords }}</strong> Total Athletes
      </span>
    </div>
  </div>

  <mat-card class="content-card">
    <mat-card-content class="p-0">
      <!-- Toolbar Filters -->
      <div class="table-toolbar">
        <div class="search-box">
          <mat-form-field
            appearance="outline"
            class="w-100 search-field"
            subscriptSizing="dynamic"
          >
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              placeholder="Search by name, email..."
              [(ngModel)]="searchQuery"
              (input)="search($event)"
            />
          </mat-form-field>
        </div>

        <div class="filter-box">
          <mat-form-field
            appearance="outline"
            class="filter-field"
            subscriptSizing="dynamic"
          >
            <mat-select
              [(value)]="constant.ALL"
              placeholder="All Status"
              (selectionChange)="onChange($event)"
            >
              <mat-option value="">All Statuses</mat-option>
              <mat-option *ngFor="let sort of sorts" [value]="sort.value">
                {{ sort.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Data Table -->
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="user-table">
          <!-- Name Column -->
          <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef>Athlete Name</th>
            <td mat-cell *matCellDef="let element">
              <div class="user-cell" (click)="openUploadedVideos(element)">
                <div class="avatar-circle">
                  <img
                    [src]="
                      element.imgUrl ||
                      element.user.imgUrl ||
                      'assets/images/logos/brand-logo.png'
                    "
                    (error)="
                      $any($event.target).src =
                        'assets/images/logos/brand-logo.png'
                    "
                    alt="Logo"
                    class="avatar-logo"
                  />
                </div>
                <div class="user-meta">
                  <span class="user-name">{{
                    element.fullName || "Unnamed Athlete"
                  }}</span>
                  <span class="user-link">View videos &rarr;</span>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Email Column -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email Address</th>
            <td mat-cell *matCellDef="let element">
              <span class="email-text">{{ element.email }}</span>
            </td>
          </ng-container>

          <!-- Total Videos Column -->
          <ng-container matColumnDef="totalVideos">
            <th mat-header-cell *matHeaderCellDef>Videos</th>
            <td mat-cell *matCellDef="let element">
              <button
                mat-stroked-button
                class="video-badge-btn"
                (click)="openUploadedVideos(element)"
                [disabled]="!element.totalVideos"
              >
                <mat-icon>videocam</mat-icon>
                <span>{{ element.totalVideos || 0 }} Videos</span>
              </button>
            </td>
          </ng-container>

          <!-- Performance Score Column -->
          <ng-container matColumnDef="totalPunches">
            <th mat-header-cell *matHeaderCellDef>Performance Score</th>
            <td mat-cell *matCellDef="let element">
              <div class="score-chip">
                <mat-icon>sports_mma</mat-icon>
                <span>{{ element.totalPunches || 0 }}</span>
              </div>
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
              <span
                class="status-badge"
                [ngClass]="
                  element.status?.toLowerCase() === 'active'
                    ? 'active'
                    : 'inactive'
                "
              >
                <span class="dot"></span>
                {{ element.status || "Active" }}
              </span>
            </td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="text-right">
              Actions
            </th>
            <td mat-cell *matCellDef="let element" class="text-right">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                class="action-btn"
                aria-label="User actions"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu" class="action-dropdown">
                <button
                  (click)="changeProfileStatus(element, 'active')"
                  mat-menu-item
                >
                  <mat-icon class="text-success">check_circle</mat-icon>
                  <span>Set Active</span>
                </button>
                <button
                  (click)="changeProfileStatus(element, 'inactive')"
                  mat-menu-item
                >
                  <mat-icon class="text-warning">pause_circle</mat-icon>
                  <span>Set inactive</span>
                </button>
                <mat-divider></mat-divider>
                <button
                  (click)="deleteItem(element)"
                  mat-menu-item
                  class="delete-item"
                >
                  <mat-icon color="warn">delete</mat-icon>
                  <span class="text-danger">Delete User</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="table-row"
          ></tr>
        </table>
      </div>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="dataSource?.data?.length === 0">
        <mat-icon>search_off</mat-icon>
        <h3>No Athletes Found</h3>
        <p>No user records matched your current query or filter criteria.</p>
      </div>

      <!-- Paginator -->
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 50, 100]"
        (page)="onPageChange($event)"
        showFirstLastButtons
      >
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
